import store from '../store';

export default async function entryCompanyProfile({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryCompanyProfile');
   
    if (store.getters.isAuthenticated)   
        return router.push({ name: "CompanySearch" });
    else       
        return router.push({ name: "Login" });
    
    
    return next();
}
